@import '../../../../style/src/typography/mixins';

.zds-form-label {
	@include zds-typography('body');

	color: var(--zds-text-color-base);
	display: inline-block;

	// Reset browser styling when legend is used
	float: none;
	font-weight: var(--zds-input-label-font-weight);
	margin-bottom: var(--zds-space-2);
	width: auto;

	.zds-asterisk {
		margin-right: 1px;
	}

	.wrapper {
		display: flex;
	}
}
